<template>
  <div
    :class="`flex flex-${align ?? 'col'} gap-2 simple-input-group ${align === 'row' ? 'items-center' : ''}`"
  >
    <label class="truncate" :for="name">{{
      props.label ? t(`labels.${props.label}`) : t(`labels.${props.name}`)
    }}</label>
    <Checkbox :id="name" v-model="internalValue" :disabled="disabled" binary />
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  name: string;
  modelValue: boolean | undefined;
  label?: string;
  disabled?: boolean;
  align?: 'col' | 'row';
}>();

const { t } = useI18n();

const internalValue = ref(props.modelValue);

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean | undefined): void;
}>();

watch(internalValue, (newValue) => {
  emit('update:modelValue', newValue);
});

watch(
  () => props.modelValue,
  (newValue) => {
    internalValue.value = newValue;
  },
);
</script>
